import * as Actions from 'actions';
import * as ReactRedux from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import CustomPropTypes from 'CustomPropTypes';
import PopupGroupBoxListItem from 'PopupGroup/PopupGroupBoxListItem';
import { toolboxItemTypeToTracking } from 'Popups';
import { updateGroupPopupQuestion, endEditingGroup } from 'PopupGroup/PopupGroupActions';
import { AnimationActions } from 'Animation';
import { bindActionCreators } from 'redux';
import { addFieldToSectionOrganizer } from 'SelfServePostBuilderSidePanel/SectionOrganizer/SectionOrganizerActions';
import { enablePopupCreation } from 'SelfServeBuilder/SelfServeBuilderActions';

import styles from '../../sass/main.scss';

class PopupGroupEditingBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onLabelChange = this.onLabelChange.bind(this);
    this.onDone = this.onDone.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onLabelFocus = this.onLabelFocus.bind(this);
    this.renderLabels = this.renderLabels.bind(this);
    this.isFinished = this.isFinished.bind(this);

    const groupedPopupIds = props.popupGroup.fieldIds;
    const popupLabels = {};
    for (let i = 0; i < groupedPopupIds.length; i += 1) {
      const id = groupedPopupIds[i];
      popupLabels[id] = props.popupsInGroup[id].label;
    }

    this.state = {
      isFinished: false,
      questionLabel: props.popupGroup.label,
      popupLabels,
    };
  }

  componentDidMount() {
    this.popupGroupEditingBox.focus();
  }

  onChange(e) {
    this.setState({
      showError: false,
      questionLabel: e.target.value,
    });
  }

  onLabelChange(id, e) {
    e.persist();
    this.setState(prevState => ({
      showError: false,
      popupLabels: {
        ...prevState.popupLabels,
        [id]: e.target.value,
      },
    }));
  }

  onLabelFocus(id) {
    this.props.setActivePopup(id);
  }

  onDone() {
    const isFinished = this.isFinished();
    if (!isFinished) {
      this.props.showError(true);
      return;
    }
    const { activePopup, popupGroup, groupId, popupsInGroup } = this.props;

    window._track(`Done | ${toolboxItemTypeToTracking[popupsInGroup[activePopup].type]}`, 'Template Builder');

    const initialPopupId = popupGroup.fieldIds[0];
    this.props.updateGroupPopupQuestion(this.props.groupId, this.state.questionLabel);
    const groupedPopupIds = popupGroup.fieldIds;
    for (let i = 0; i < groupedPopupIds.length; i += 1) {
      const id = groupedPopupIds[i];
      this.props.onAttributesChanged(id, {
        label: this.state.popupLabels[id],
      });
    }
    this.props.addPaddingTop(initialPopupId, 0);
    this.props.startPlacementDoneAnimation(activePopup, popupsInGroup[activePopup].type);
    // Set isEditingGroup to false but dont deactivate the popup or group
    this.props.endEditingGroup();
    this.props.endEditingPopup();
    this.props.addFieldToSectionOrganizer(groupId);
    this.props.enablePopupCreation();
    this.props.showError(false);
  }

  onResize() {
    const inputHeight = this.props.getHeight();
    if (inputHeight !== this.state.inputHeight) {
      this.props.onResize(inputHeight);
      const popupGroup = this.props.popupGroup;
      const initialPopupId = popupGroup.fieldIds[0];
      this.props.addPaddingTop(initialPopupId, inputHeight);
    }
  }

  isFinished() {
    const { questionLabel, popupLabels } = this.state;
    if (!questionLabel) {
      return false;
    }
    const popupGroup = this.props.popupGroup;

    const groupedPopupIds = popupGroup.fieldIds;
    return groupedPopupIds.filter(id => !popupLabels[id]).length === 0;
  }

  renderLabels() {
    const popupGroup = this.props.popupGroup;
    const groupedPopupIds = popupGroup.fieldIds;
    return (
      <React.Fragment>
        <ul className="group-box-popup-ul">
          {
            groupedPopupIds.map((id, index) => (
              <PopupGroupBoxListItem
                activePopup={this.props.activePopup}
                id={id}
                index={index}
                key={id}
                onResize={this.onResize}
                onLabelChange={this.onLabelChange}
                onLabelFocus={this.onLabelFocus}
                value={this.state.popupLabels[id]}
                type={popupGroup.type}
              />
            ))
          }
        </ul>
      </React.Fragment>
    );
  }

  render() {
    const isFinished = this.isFinished();
    let doneBtnStyle = {};
    if (!isFinished) {
      doneBtnStyle = {
        backgroundColor: styles.sectionOrganizerDividerEditDoneBtnDisabledColor,
      };
    }
    const questionLabels = this.renderLabels();
    return (
      <React.Fragment>
        <div className="group-box-popup-inner-wrapper">
          <div
            className="group-box-question-wrapper"
            style={{ borderColor: this.props.borderColor }}
          >
            <TextareaAutosize
              className="box-popup-name-input-textarea"
              maxRows={9}
              onChange={this.onChange}
              onResize={this.onResize}
              placeholder="Type question here..."
              rows={1}
              value={this.state.questionLabel}
              ref={(ref) => { this.popupGroupEditingBox = ref; }}
            />
          </div>
          {questionLabels}
          <div className="group-box-popup-instructions">
            Click on the document to <b>{this.props.instructionText}</b> for your recipient.
          </div>
        </div>
        <div className="group-box-done-btn-wrapper">
          <button
            className="box-popup-name-input-done-btn"
            onClick={this.onDone}
            style={doneBtnStyle}
          >
            Done
          </button>
        </div>
      </React.Fragment>
    );
  }
}

PopupGroupEditingBox.propTypes = {
  activePopup: PropTypes.string.isRequired,
  addFieldToSectionOrganizer: PropTypes.func.isRequired,
  addPaddingTop: PropTypes.func.isRequired,
  borderColor: PropTypes.string.isRequired,
  enablePopupCreation: PropTypes.func.isRequired,
  endEditingGroup: PropTypes.func.isRequired,
  endEditingPopup: PropTypes.func.isRequired,
  getHeight: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  instructionText: PropTypes.string.isRequired,
  onAttributesChanged: PropTypes.func.isRequired,
  onResize: PropTypes.func.isRequired,
  popupsInGroup: CustomPropTypes.hashmapOf(
    PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.string,
    }),
  ).isRequired,
  popupGroup: PropTypes.shape({
    label: PropTypes.string,
    type: PropTypes.string,
    pageIndex: PropTypes.number,
    fieldIds: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  updateGroupPopupQuestion: PropTypes.func.isRequired,
  setActivePopup: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  startPlacementDoneAnimation: PropTypes.func.isRequired,
};

const mapStateToProps = ({ popupHandler }) => ({
  activePopup: popupHandler.activePopup,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    addFieldToSectionOrganizer,
    enablePopupCreation,
    endEditingGroup,
    endEditingPopup: Actions.endEditingPopup,
    onAttributesChanged: Actions.changePopup,
    setActivePopup: Actions.setActivePopup,
    startPlacementDoneAnimation: AnimationActions.startSelfServeBuilderFieldPlacementDoneAnimation,
    updateGroupPopupQuestion,
  }, dispatch)
);

export default ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PopupGroupEditingBox);



// WEBPACK FOOTER //
// ./src-react/PopupGroup/PopupGroupEditingBox.jsx